import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Insignia from './insignia';

import styles from '../styles/uikitInsigniasInsignias.module.scss';

const Insignias = ({
  className = '',
  insignias,
  // TODO: Rename to iconSize, currently redundant
  insigniasIconSize = 12,
  // TODO: Rename to shouldShowSeparator, currently redundant
  shouldShowInsigniasSeparator = false,
  // TODO: Rename to shouldShowText, currently redundant
  shouldShowInsigniasText = true,
  testId = '',
  textVariant = '',
}) => (
  <div className={classnames(styles.element, className)} data-testid={testId}>
    {insignias?.map((insignia) => (
      <Insignia
        ariaLabel={insignia.ariaLabel}
        key={insignia.icon}
        iconSize={insigniasIconSize}
        icon={insignia.icon}
        testId={insignia.testId}
        text={insignia.text}
        textVariant={textVariant}
        tooltip={insignia.tooltip}
        shouldShowInsigniasText={shouldShowInsigniasText}
        shouldShowInsigniasSeparator={shouldShowInsigniasSeparator}
      />
    ))}
  </div>
);

Insignias.propTypes = {
  className: PropTypes.string,
  insignias: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
      testId: PropTypes.string,
    }),
  ).isRequired,
  insigniasIconSize: PropTypes.number,
  textVariant: PropTypes.string,
  shouldShowInsigniasSeparator: PropTypes.bool,
  shouldShowInsigniasText: PropTypes.bool,
  testId: PropTypes.string,
};

export default React.memo(Insignias);
